
import { Component, Vue } from 'vue-property-decorator';
/**
 * 内部页面
 */
@Component({
    name: 'HorizontalSlidePage',
})
export default class HorizontalSlidePage extends Vue {}
